function componentToHex(color: number) {
    var hex = color.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}

function rgbToHex(color: number[]) {
    return '#' + componentToHex(color[0]) + componentToHex(color[1]) + componentToHex(color[2]);
}

function isHexadecimal(color: string): boolean {
    if (color.length > 7) {
        return false;
    }

    const regEx = /^#([0-9a-f]{3}){1,2}$/i;
    return regEx.test(color);
}

function toHexadecimal(color: string): string {
    if (!isHexadecimal(color)) {
        return '';
    }

    if (color.length > 4) {
        return color.toLowerCase();
    }

    const value = color.toLowerCase().substring(1);

    const sixDigitsValue = value
        .split('')
        .map(hex => hex + hex)
        .join('');

    return '#' + sixDigitsValue;
}

function isHexadecimalWithTransparency(color: string): boolean {
    if (color.length <= 7 || color.startsWith('rgb')) {
        return false;
    }

    return true;
}

function toHexadecimalWithTransparency(color: string): string {
    if (!isHexadecimalWithTransparency(color)) {
        return '';
    }

    if (color.length > 9) {
        return color.toLowerCase();
    }

    const value = color.toLowerCase().substring(1);

    const eightDigitsValue = value.length === 7 ? value + '0' : value;

    return '#' + eightDigitsValue;
}

function isRgbColor(color: string): boolean {
    return color.startsWith('rgb');
}

function toRgb(color: string): string {
    if (!isRgbColor(color)) {
        return '';
    }

    const values = color.split(',').map((color: string) => ~~color.replace(/\D+/g, ''));

    color = rgbToHex(values);

    return color;
}

export const formatColor = (color: string | null | undefined) => {
    if (!color) {
        return '';
    }

    if (isHexadecimal(color)) {
        return toHexadecimal(color);
    }

    if (isRgbColor(color)) {
        return toRgb(color);
    }
    if (isHexadecimalWithTransparency(color)) {
        return toHexadecimalWithTransparency(color);
    }

    return '';
};
